import { get } from 'lodash';
import { MEMBERS_APP_ID, SANTA_MEMBERS_APP_ID, MEMBER_INFO_APP_ID } from '../constants/applications';
import applicationAdded from '../actions/application-added';
import applicationDeleted from '../actions/application-deleted';
import TpaInstallListener from './tpa-install-listener';
import { getCommunitiesContext } from '../selectors/communities-context-selectors';
import Wix from './wix-sdk-polyfill';

export default function listenToAppInstall(store) {
  const isEditor = ['editor', 'preview'].indexOf(Wix.Utils.getViewMode()) > -1;

  if (isEditor) {
    const context = getCommunitiesContext(store.getState());

    isMemberAppInstalled(context, store);
    isMemberAreaInstalled(context, store);

    const listener = new TpaInstallListener([MEMBERS_APP_ID, MEMBER_INFO_APP_ID], 2000);
    listener.onInstall(
      (appDefinitionId, instanceId) => {
        store.dispatch(applicationAdded({
          appDefinitionId: getAppDefinitionId(appDefinitionId),
          instanceId,
        }));
      }
    );
    listener.onDelete(appDefinitionId => {
      store.dispatch(applicationDeleted({ appDefinitionId: getAppDefinitionId(appDefinitionId) }));
    });
    listener.listen();
  }
}

function isMemberAppInstalled(context, store) {
  Wix.isApplicationInstalled(MEMBERS_APP_ID, isInstalled => {
    if (isInstalled !== get(context, `[${MEMBERS_APP_ID}].isInstalled`)) {
      if (isInstalled) {
        Wix.getInstalledInstance(MEMBERS_APP_ID, ({ instanceId }) => {
          store.dispatch(applicationAdded({ appDefinitionId: MEMBERS_APP_ID, instanceId }));
        });
      } else {
        store.dispatch(applicationDeleted({ appDefinitionId: MEMBERS_APP_ID }));
      }
    }
  });
}

function isMemberAreaInstalled(context, store) {
  Wix.isApplicationInstalled(MEMBER_INFO_APP_ID, isInstalled => {
    if (isInstalled !== get(context, `[${SANTA_MEMBERS_APP_ID}].isInstalled`)) {
      if (isInstalled) {
        store.dispatch(applicationAdded({ appDefinitionId: SANTA_MEMBERS_APP_ID, instanceId: null }));
      } else {
        store.dispatch(applicationDeleted({ appDefinitionId: SANTA_MEMBERS_APP_ID }));
      }
    }
  });
}

function getAppDefinitionId(appDefinitionId) {
  return appDefinitionId === MEMBER_INFO_APP_ID ? SANTA_MEMBERS_APP_ID : appDefinitionId;
}



// WEBPACK FOOTER //
// ./app/services/listen-to-app-install.js